import { Controller } from 'react-hook-form';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Select2, type Select2Option } from './Select2';

interface Select2FieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  options: Select2Option[];
  placeholder?: string;
  searchable?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  className?: string;
}

// react-hook-form bridge for Select2 (select2 is a controlled jQuery plugin, so it
// can't bind to RHF `register` — use this with `control` instead).
export function Select2Field<T extends FieldValues>({ control, name, ...rest }: Select2FieldProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Select2
          {...rest}
          value={field.value == null ? '' : String(field.value)}
          onChange={(v) => field.onChange(v)}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
